module.exports = __webpack_public_path__ + "img/1.9f177e26.jpg";